<template>
  <div class="card">
    <header class="header-card" v-if="fullYear">
      <p>
        {{ $t('catalogue.newProduct.tab.dispo') }}
      </p>
    </header>

    <div class="card">
      <div class="card-content checkbox-custom-disabled">
        <b-checkbox v-model="produit.controleDisponibilite"
                    :disabled="isDisabled">
          {{ $t('catalogue.newProduct.controleDisponibilite') }}
        </b-checkbox>
        <div class="has-text-centered has-background-background
                    pdt-20px pdb-20px"
             v-if="!produit.id">
          <h1 class="title is-size-4">
            {{ $t('catalogue.dispo.anyDispo')}}
          </h1>
        </div>
        <div v-else class="mgt-20px">
          <p class="has-text-link mgb-20px" v-if="!isDisabled">
            {{ $t('catalogue.dispo.selectDispoReseau') }}
          </p>
          <pagination
            :firstNumber="fullYear"
            :numberDisplay="10"
            @changementPage="changementAnnee"
          >
          </pagination>
          <div v-for="(month, indexMonth) in allDayInYear" :key="indexMonth"
               class="columns is-multiline">
            <div class="column is-12 has-text-link">
              {{ month.mois }} </div>
            <div v-for="indexDay in (parseInt(month.days.length / 2) + 1)" :key="indexDay"
                 class="column is-1-fullhd is-2-desktop is-paddingless">
              <b-field>
                <div @click="changementDispo(month.days[(indexDay * 2) - 2])"
                     v-if="month.days.length > (indexDay * 2) - 2
              || indexDay === 1"
                     :class="[getClasse(month.days[(indexDay * 2) - 2]),
                   {'is-cursor-pointer' : !isDisabled}]">
                  <p class="is-size-7 has-text-centered has-text-link mgt-5px
                has-text-weight-bold">
                    {{month.days[(indexDay * 2) - 2].day}}
                  </p>
                  <p v-if="!!popUpName && popUpName !== 'dispoFace'"
                     class="has-text-centered has-text-default is-size-8 mgt-5px">
                    {{month.days[(indexDay * 2) - 2].stock}}
                  </p>
                  <p v-if="month.days[(indexDay * 2) - 2].commentaire && popUpName === 'dispoFace'"
                     class="has-text-centered">
                    <b-tooltip :label="month.days[(indexDay * 2) - 2].commentaire"
                               position="is-top" multilined>
                      <b-icon icon="comment-eye" size="is-small"></b-icon>
                    </b-tooltip>
                  </p>
                </div>
                <div @click="changementDispo(month.days[indexDay * 2 - 1])"
                     v-if="month.days.length > (indexDay * 2) - 1
              || indexDay === 1"
                     :class="[getClasse(month.days[(indexDay * 2) - 1]),
                   {'is-cursor-pointer' : !isDisabled}]">
                  <p class="is-size-7 has-text-centered has-text-link mgt-5px
                has-text-weight-bold">
                    {{month.days[indexDay * 2 - 1].day}}
                  </p>
                  <p v-if="!!popUpName && popUpName !== 'dispoFace'"
                     class="has-text-centered has-text-default is-size-8 mgt-5px">
                    {{month.days[indexDay * 2 - 1].stock}}
                  </p>
                  <p v-if="month.days[indexDay * 2 - 1].commentaire
                  && popUpName === 'dispoFace'" class="has-text-centered">
                    <b-tooltip :label="month.days[(indexDay * 2) - 1].commentaire"
                               position="is-top" multilined>
                    <b-icon icon="comment-eye" size="is-small"></b-icon>
                    </b-tooltip>
                  </p>
                </div>
                <div v-else class="dispo-face">
                </div>
              </b-field>
            </div>
          </div>
          <b-modal v-model="popUpChangementDispoFace" has-modal-card class="modal"
                   v-if="popUpChangementDispoFace">
            <pop-up-dispo-face :infoJourSelect="infoDaySelect"
                               @reloadDispoFace="changementAnnee(fullYear)"
            ></pop-up-dispo-face>
          </b-modal>
          <b-modal v-model="popUpChangementDispoEcranNumerique" has-modal-card class="modal"
                   v-if="popUpChangementDispoEcranNumerique">
            <pop-up-dispo-ecran-numerique :infoJourSelect="infoDaySelect"
                                          @reloadDispoFace="changementAnnee(fullYear)"
            ></pop-up-dispo-ecran-numerique>
          </b-modal>
          <b-modal v-model="popUpChangementDispoReseauNumerique" has-modal-card class="modal"
                   v-if="popUpChangementDispoReseauNumerique">
            <pop-up-dispo-reseau-numerique :infoJourSelect="infoDaySelect"
                                           @reloadDispoFace="changementAnnee(fullYear)"
            ></pop-up-dispo-reseau-numerique>
          </b-modal>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import Pagination from '@/components/general/pagination';
import { getDisponibilites } from '@/api/dispo';
import genererDispoParJour from '@/services/catalogue/genererDispoParJour';
import messageErreur from '@/services/general/messageErreur';
import popUpDispoFace from '@/components/catalogue/dispo/p_DispoFace';
import popUpDispoEcranNumerique from '@/components/catalogue/dispo/p_DispoEcranNumerique';
import popUpDispoReseauNumerique from '@/components/catalogue/dispo/p_DispoReseauNumerique';

export default {
  props: {
    produit: {
      type: Object,
      required: true,
    },
    popUpName: {
      type: String,
      required: false,
    },
    isDisabled: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      allDayInYear: [],
      fullYear: new Date().getFullYear(),
      popUpChangementDispoFace: false,
      popUpChangementDispoEcranNumerique: false,
      popUpChangementDispoReseauNumerique: false,
      infoDaySelect: {},
    };
  },
  components: {
    Pagination,
    popUpDispoFace,
    popUpDispoEcranNumerique,
    popUpDispoReseauNumerique,
  },
  methods: {
    async changementAnnee(nouvelleAnnee) {
      this.fullYear = nouvelleAnnee;
      const loadingComponent = this.$buefy.loading.open();
      try {
        const dispoParJour = (await getDisponibilites(
          this.produit.id, this.fullYear,
        )).data.result;
        this.allDayInYear = await genererDispoParJour(dispoParJour);
        loadingComponent.close();
      } catch (e) {
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }
    },
    getClasse(displayDay) {
      let classe = 'has-background-indispo dispo-face';
      if (displayDay.stock) classe = 'has-background-dispo dispo-face';
      if (displayDay.isToday) classe += ' bordure-semaine-actuelle';
      return classe;
    },
    changementDispo(day) {
      if (this.isDisabled) return;
      this.infoDaySelect = day;
      switch (this.popUpName) {
        case 'dispoFace':
          this.popUpChangementDispoFace = true;
          break;
        case 'dispoEcranNumerique':
          this.popUpChangementDispoEcranNumerique = true;
          break;
        case 'dispoReseauNumerique':
          this.popUpChangementDispoReseauNumerique = true;
          break;
        default:
          this.popUpChangementDispoFace = true;
      }
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      if (this.produit.id) {
        const dispoParJour = (await getDisponibilites(
          this.produit.id, this.fullYear,
        )).data.result;
        this.allDayInYear = await genererDispoParJour(dispoParJour);
      }
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
  },
};
</script>
